import { ContentRenderer } from '@components/renderer/base'
import { buildSectionRenderer } from '@components/renderer/section/generic'

export const SectionRenderer = buildSectionRenderer(ContentRenderer)
